// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import 'chart.js'
import 'hchs-vue-charts'
import Axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'fullpage.js/dist/jquery.fullpage.js'
import 'fullpage.js/dist/jquery.fullpage.css'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBiEZKw7333oZoTvRpoyy2Ynmwl4RADpHY',
    libraries: 'places'
  }
})
Vue.prototype.$http = Axios
Vue.use(window.VueCharts)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js